<div class="item-container">
  <div class="item-header">
    <h5 class="text-center" *ngIf="!dialogData">{{'COMMON.ADD' | translate}} {{'MENUITEMS.FORUMMANAGEMENT.FORUM' | translate}}</h5>
    <h5 class="text-center" *ngIf="dialogData?.id"> {{'COMMON.EDIT' | translate}} {{'MENUITEMS.FORUMMANAGEMENT.FORUM' | translate}}</h5>
    <div class="edit-icons" (click)="onCancel()">
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content">
  
    <form action="" [formGroup]="forumForm" (ngSubmit)="onSubmit()">
      <div class="modal-overflow">
      <div class="row mt-4">
        <div class="col-xl-4 mt-3 ">
          <div class="drop-box" *ngIf="(!forumData?.img && !imagePath)">
            <ngx-dropzone (change)="onSelect($event)" class="drop-item" accept="image/jpeg,image/jpg,image/png">
              <ngx-dropzone-label >
                  <div class="d-flex flex-column align-items-center">
                      <div class="upload-img mr-2">
                          <img src="assets/images/icons/upload.svg" class="img-fluid">
                      </div>
                      <div>
                          <div>{{"COMMON.CTU" | translate}}</div>
                          <div class="upload-text">{{"COMMON.DD" | translate}}</div>
                      </div>
                  </div>
              </ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of files"  (removed)="onRemove(f)" [removable]="true" >
                  <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
          </div>
          <div class="c-box" *ngIf="(forumData?.img || imagePath)" >
            <div class="cer-b"   >  
                <div class="cer-i" *ngIf="imagePath" [style.backgroundImage]="'url('+ imagePath +')'"></div>    
                <div class="cer-i" *ngIf="forumData?.img" [style.backgroundImage]="'url('+ forumData.img +')'"></div>                         
            </div>                           
            <div class="e-ic d-flex align-items-center justify-content-center"  (click)="drop.showFileSelector()">
                <i class="material-icons">mode_edit</i>
            </div> 
            <ngx-dropzone #drop 
            accept="image/jpeg,image/jpg,image/png"
            (change)="onSelect($event)" class="d-none" [multiple]="false"></ngx-dropzone>
        </div>
        </div>
        <div class="col-xl-8">
          <div class="row">
            <div class="col-12 mt-3">
              <label for="">{{ "COMMON.TITLE" | translate }}</label>
              <div class="form-input">
                <input type="text" class="form-control" placeholder="Enter Title" formControlName="tit" />
              </div>
              <mat-error *ngIf="isControlHasError('tit', 'required')"> {{ "COMMON.THR" | translate }}</mat-error>
              <mat-error *ngIf="isControlHasError('tit', 'minlength')"> {{ "VALIDATION.TITLE" | translate }}</mat-error>
          
            </div>
            <div class="col-12 mt-3">
              <label for="">{{ "COMMON.DEP" | translate }}</label>
              <div>
                <ng-multiselect-dropdown formControlName="d_i" [settings]="dropdownSettings" [data]="departmentData"> </ng-multiselect-dropdown>
              </div>
              <mat-error *ngIf="isControlHasError('d_i', 'required')"> {{ "COMMON.THR" | translate }}</mat-error>
            </div>
          </div>
        </div> 
      </div>
      <div class="mt-3 pt-xl-3">
        <div>
          <label for="">{{ "COMMON.DESC" | translate }}</label>
        </div>
        <quill-editor [styles]="{ width: '100%', height: '120px',display:'block' }" class="d-block"  formControlName="desc"></quill-editor>
        <div class="mb-3">
          <mat-error *ngIf="isControlHasError('desc', 'required')"> {{ "COMMON.THR" | translate }}</mat-error >
            <mat-error *ngIf="isControlHasError('desc', 'minlength')"> {{ "VALIDATION.TITLE" | translate }}</mat-error>
        </div>
      </div>
    </div>
      
    </form>
  </div>
  <div class="row">
    <div class="col-md-6 m-auto mt-xl-2 text-center">
      <button (click)="onSubmit()"
        mat-raised-button 
        color="primary"
        class="auth-form-btn mt-3 mt-lg-4 text-center"
        type="submit" >
        {{ "BUTTON.SAVE" | translate }}
      </button>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>